import { HeadingSectionProperties } from '../components/heading-section/heading-section-types.js';
const SubSectionProperties = {
    ...HeadingSectionProperties,
};
export { SubSectionProperties, };
//# sourceMappingURL=subsection-types.js.map